import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="pt-40 pb-40 text-center px-6" data-testid="payment-cancel-page">
      <XCircle size={52} strokeWidth={1} className="text-[#B8B8B8] mx-auto" />
      <h1 className="font-serif-display text-4xl text-white mt-8">Checkout was canceled</h1>
      <p className="font-sans-body text-sm text-[#B8B8B8] font-light mt-4 max-w-md mx-auto">
        No payment was taken and no order was placed. Your bag is still saved — you can
        pick up right where you left off.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
        <Link to="/checkout" className="btn-gold" data-testid="cancel-return-checkout">Return to Checkout</Link>
        <Link to="/shop" className="btn-outline-gold" data-testid="cancel-continue-shopping">Continue Shopping</Link>
      </div>
    </div>
  );
}
